// REDUCER FOR log in
export function userDetail(state = {}, action) {
    switch (action.type) {
        case 'LOGGED_USER_DETAILS':
        // console.log(action.data,"L55555");
            return action.data
        default:
            return state
    }
}